module.exports = __webpack_public_path__ + "01_hige_gray.edcdd857.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/01_hige_gray.png
// module id = Lg38
// module chunks = 0